
    var riot = require('riot')
    
riot.tag2('projects', '<div if="{!projects || !cal_events}"><br> <div class="alert alert-info"><br> <h4></h4><span class="fa fa-spinner fa-spin"></span> Loading Data </div> </div> <div if="{error}" class="alert alert-danger">{error}</div> <div if="{activeprojects}"> <h2>Projects</h2> <div class="row"> <div each="{activeprojects}" class="col-md-3"> <div class="panel panel-default"> <div class="panel-heading"> <small class="pull-right">{work_done_total} / {scheduled_total} hrs</small><a href="{http_url_to_repo}" target="_blank">{name} </a></div> <div class="panel-body showlist"> <div class="row"> <div class="col-xs-2 text-center"><span class="fa fa-clock-o"></span></div> <div class="col-xs-10"> <progressbar value="{work_done_total}" max="{scheduled_total}" bsstyle="{scheduled_total&lt;work_done_total?\'danger\':\'success\'}">{time_label}</progressbar> </div> </div> <div class="row"> <div class="col-xs-2 text-center"><span class="fa fa-check-square"></span></div> <div class="col-xs-10"> <progressbar value="{issues_touched}" max="{issues.length}" bsstyle="warning">{issues_touched}/{issues.length}</progressbar> </div> <table class="table table-striped"> <thead> <tr> <th></th> <th>Issues</th> <td>Assigned</td> <td>Hrs</td> </tr> </thead> <tbody> <tr each="{issues}"> <td class="text-center"> <span if="{calendar_activity.length}" class="fa fa-check-square"></span></td> <td><small>{title}</small></td> <td><small>{assignee.name}</small></td> <td><small>{work_done}/{time_todo}</small></td> </tr> </tbody> </table> </div> </div> </div> </div> </div> <h2>Team</h2> <table class="table team"> <thead> <tr> <th>Name </th> <th each="{val,idx in alldates}"> <span title="{val}">{val.replace(/[0-9]+-[0-9]+-/,⁗⁗)}</span><br><small style="font-size:10px">{alldays[idx]}</small></th> </tr> </thead> <tbody> <tr each="{key,value  in users}"> <td>{key} - {value.total/10} hrs</td> <td each="{value.events}" title="{duration}" riot-style="{colourFromTime(duration)}"><small class="duration">{parent.round(duration)}</small></td> </tr> </tbody> </table> </div>', 'projects h2 { margin-top: 10px; margin-bottom: 5px; } projects .progress { margin-bottom: 5px; } .showlist .table { display: none; } .showlist:hover .table { display: table; } .team.table th, .team.table td { padding: 2px; font-weight: normal; border-right: 1px solid #ddd; min-width: 25px; } small.duration { font-size: 10px; text-align: center; display: block; line-height: 25px; }', '', function(opts) {
var days, enddate, n, s, sameday, startdate;

this.projects = null;

this.cal_events = null;

this.error = null;

days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

sameday = function(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
};

this.asday = function(d) {
  return d.getFullYear() + "-" + (1 + d.getMonth()) + "-" + d.getDate();
};

this.asdayletter = function(d) {
  return days[d.getDay()];
};

this.round = function(val) {
  if (val) {
    return Math.round(val * 10) / 10;
  } else {
    return "";
  }
};

n = new Date();

startdate = new Date(n.getFullYear(), n.getMonth() - 2, 1);

enddate = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1);

this.alldates = [];

this.alldays = [];

s = startdate;

while (s < enddate) {
  this.alldates.push(this.asday(s));
  this.alldays.push(this.asdayletter(s));
  s = new Date(s.setDate(s.getDate() + 1));
}

this.on("mount", function() {
  return this.load_data();
});

this.on("update", function() {
  var err, ev, i, idx, len, prevdate, ref, ref1, tagged_events, thisdate;
  if ((ref = this.cal_events) != null ? ref.length : void 0) {
    tagged_events = this.cal_events.filter(function(ev) {
      return ev.title.match(/#([0-9]+|admin|dev|comms|sysadmin|accounts|invoicing|sales|hr|rd|fm|design|support)/);
    });
    try {
      this.users = {};
      prevdate = null;
      for (i = 0, len = tagged_events.length; i < len; i++) {
        ev = tagged_events[i];
        if (this.users[ev.user] == null) {
          this.users[ev.user] = {
            events: [],
            total: 0
          };
        }
        thisdate = this.asday(new Date(ev.start));
        idx = this.alldates.indexOf(thisdate);
        if (idx > -1) {
          this.users[ev.user].total += Math.round(ev.duration * 10);
          if (prevdate !== thisdate) {
            this.users[ev.user].events[idx] = ev;
            this.users[ev.user].events[idx].eventcount = 1;
            prevdate = thisdate;
          } else {
            this.users[ev.user].events[idx].duration += Math.round(ev.duration * 10) / 10;
            this.users[ev.user].events[idx].eventcount += 1;
          }
        }
      }
    } catch (error) {
      err = error;
      console.log(err);
    }
  }
  if ((ref1 = this.projects) != null ? ref1.length : void 0) {
    return this.activeprojects = this.projects.filter(function(project) {
      var e;
      try {
        project.work_done = project.issues.map(function(issue) {
          var ref2;
          issue.time_todo = Math.round((((ref2 = issue.time_stats) != null ? ref2.time_estimate : void 0) || 0) / 360) / 10;
          issue.work_done = issue.calendar_activity.reduce((function(a, activity) {
            return a + (activity.duration ? Math.round(activity.duration) : 0);
          }), 0);
          if (!issue.time_todo) {
            issue.time_todo = issue.work_done;
          }
          return issue.work_done;
        });
        project.scheduled_total = Math.round((project.issues.reduce((function(a, issue) {
          return a + issue.time_stats.time_estimate || 0;
        }), 0)) / 360) / 10;
        project.issues_touched = (project.issues.filter(function(issue) {
          var ref2;
          return ((ref2 = issue.calendar_activity) != null ? ref2.length : void 0) > 0;
        })).length;
      } catch (error) {
        e = error;
        console.log(e);
      }
      project.work_done_total = Math.round((project.work_done.reduce((function(a, b) {
        return a + b;
      }), 0)) * 10) / 10;
      project.time_label = Math.round((10 / project.scheduled_total) * project.work_done_total) * 10 + "%";
      if (project.scheduled_total === 0) {
        project.scheduled_total = project.work_done_total;
        project.time_label = "No Estimate " + project.work_done_total + "hrs";
      }
      project.show = false;
      return project.scheduled_total > 0;
    });
  }
});

this.colourFromTime = function(duration) {
  if (duration > 12) {
    return "background-color:#00243F;color:white;";
  }
  if (duration > 10) {
    return "background-color:#003B59;color:white;";
  }
  if (duration > 8) {
    return "background-color:#005574;color:white;";
  }
  if (duration > 6) {
    return "background-color:#1D6F90;color:white;";
  }
  if (duration > 4) {
    return "background-color:#428BAD";
  }
  if (duration > 2) {
    return "background-color:#9BDFFF";
  }
  if (duration > 0) {
    return "background-color:#AFF3FF";
  }
  return "background-color:#fff";
};

this.load_data = (function(_this) {
  return function() {
    return fetch("/duocms/api/projects").then(function(res) {
      return res.json();
    }).then(function(json) {
      _this.update({
        projects: json.data
      });
      return fetch("/duocms/api/projects/events");
    }).then(function(res) {
      return res.json();
    }).then(function(json) {
      return _this.update({
        cal_events: json.data
      });
    })["catch"](function(err) {
      return _this.error = err.message;
    });
  };
})(this);
});
    
  